import type { JSX } from 'solid-js';
import { AdminGate } from '../components/AdminGate';
import { AdminUsersPanel } from '../components/AdminUsersPanel';
import { SESSION_TOKEN } from '../lib/session';

// Admin user registry route. Thin: <AdminGate/> keeps the panel (and its
// `/v1/admin/users` reads + `user` MCP writes) behind the closed-beta staff
// wall. `token` is injectable for tests; the router mounts with no props.

export function AdminUsers(props: { token?: string | null } = {}): JSX.Element {
  const token = props.token ?? SESSION_TOKEN;
  return (
    <AdminGate token={token}>
      <AdminUsersPanel token={token} />
    </AdminGate>
  );
}
